import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

import {
  Row,
  Card,
  CardBody,
  Input,
  FormGroup,
  Label,
  Button,
  Form,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Table,
  CardHeader,
  CardFooter,
} from "reactstrap";
import { Colxx } from "../../../components/common/CustomBootstrap";
import Pagination from "../../../containers/pages/Pagination";
import { isNullOrEmpty } from "../../../config/ENV";
import { Link } from "react-router-dom";
import { JobBoardService } from "../../../services/JobBoardService";
import SvgUpArrow from "../../../components/svg/uparrow";
import SvgSelectedDownArrow from "../../../components/svg/selecteddownarrow";
import SvgSelectedUpArrow from "../../../components/svg/selecteduparrow";
import SvgDownArrow from "../../../components/svg/downarrow";
import {
  getPhoneNumberByCountryCode,
  formattedMobileNumber,
} from "../../../utilities/phonenumberutility";
import PhoneInput from "react-phone-input-2";

const JobBoard = () => {
  const [modalRight, setModalRight] = useState(false);
  const [size, setSize] = useState();
  const [boards, setBoards] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [mobileNumber, setMoblieNumber] = useState("");
  const [mobileNumberCountryCode, setMobileNumberCountryCode] = useState("1");
  const [jobBoardId, setJobBoardId] = useState("");
  const [modalDelete, setModalDelete] = useState(false);
  const [deleteBoard, setDeleteBoard] = useState();
  const [jobBoardName, setJobBoardName] = useState("");

  const [selectedJobBoard, setSelectedJobBoard] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  let [itemsPerPage, setItemsPerPage] = useState();
  const [totalPage, setTotalPage] = useState(1);
  const [isSortBySelected, setIsSortBySelected] = useState(false);
  const [updateImageDisabled, setUpdateImageDisabled] = useState(false);

  const [sortOrder, setSortOrder] = useState("desc");
  const [sortBy, setSortBy] = useState("name");
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [selectedPageSize, setSelectedPageSize] = useState(2);
  const startIndex = (currentPage - 1) * selectedPageSize;
  const endIndex = currentPage * selectedPageSize;
  const [selectedOrderOption, setSelectedOrderOption] = useState({
    column: "DRAFT",
    label: "DRAFT",
  });
  const [jobBoardDetails, setJobBoardDetails] = useState({
    name: "",
    // email: '',
    // mobileNumber: '',
    description: "",
    logo: "",
  });

  const inputsHandler = (e) => {
    const { name, value } = e.target;
    setJobBoardDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const openJobBoardModel = () => {
    setModalRight(true);
    setUploadedImageUrl("");
    setJobBoardId("");
    setJobBoardDetails((prevState) => ({
      ...prevState,
      name: "",
      // email: '',
      // mobileNumber: ' ',
      description: "",
    }));
    setPhoneNumber("");
  };

  function handleItemsPerChange(e, key) {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  }
  function handleSearch(e, key) {
    setSearch(e.target.value);
  }
  function onChangePage(e) {
    setCurrentPage(e);
    // currentPage(true);
  }
  const sortByJobs = (col) => {
    setIsSortBySelected(true);
    setSortBy(col);
    sortedOrder(col, true);
  };

  const sortedOrder = (col, isSortBySelected) => {
    var select = "";
    if (sortOrder === "desc") {
      setSortOrder("asc");
      select = "asc";
    } else {
      setSortOrder("desc");
      select = "desc";
    }
    getjobBoard(select, col, currentPage, true);
  };
  const handlePhoneNumber = (value, country) => {
    setPhoneNumber(value);
    if (country != null) {
      let dialCode = country.dialCode;
      let countryCode = country.countryCode;
      let dialCodeLength = dialCode.length;
      let number = value.slice(dialCodeLength).replace(/\D/g, "");
      let mobileNumber = getPhoneNumberByCountryCode(number, countryCode);
      setMobileNumberCountryCode(dialCode);
      setMoblieNumber(mobileNumber);
    }
  };

  let count = 0;
  useEffect(() => {
    getjobBoard(sortOrder, sortBy, currentPage, isSortBySelected);
  }, [itemsPerPage, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedPageSize, selectedOrderOption]);
  const getjobBoard = (sortOrder, sortBy, currentPage, isSortBySelected) => {
    setCurrentPage(currentPage);
    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }

    if (sessionStorage.getItem("jobBoardSortBy") !== null) {
      const sortByValue = sessionStorage.getItem("jobBoardSortBy");
      if (!isNullOrEmpty(sortByValue)) {
        if (!isSortBySelected) {
          sortBy = sortByValue;
          setSortBy(sortBy);
        } else {
          sessionStorage.setItem("jobBoardSortBy", sortBy);
        }
      } else {
        sessionStorage.setItem("jobBoardSortBy", sortBy);
      }
    } else {
      sessionStorage.setItem("jobBoardSortBy", sortBy);
    }

    if (sessionStorage.getItem("jobBoardSortOrder") !== null) {
      const sortOrderValue = sessionStorage.getItem("jobBoardSortOrder");
      if (!isNullOrEmpty(sortOrderValue)) {
        if (!isSortBySelected) {
          sortOrder = sortOrderValue;
          setSortOrder(sortOrder);
        } else {
          sessionStorage.setItem("jobBoardSortOrder", sortOrder);
        }
      } else {
        sessionStorage.setItem("jobBoardSortOrder", sortOrder);
      }
    } else {
      sessionStorage.setItem("jobBoardSortOrder", sortOrder);
    }
    JobBoardService.getJobBoards(
      search,
      itemsPerPage,
      currentPage,
      sortBy,
      sortOrder
    ).then((response) => {
      let size = response.data.size;
      setSize(size);
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (!isNullOrEmpty(response.data)) {
            var boardDetails = response.data;
            setBoards(boardDetails.jobBoards);
            const pages = Math.floor(size / itemsPerPage);
            if (Math.round(size % itemsPerPage) > 0) {
              const totalPages = pages + 1;
              setTotalPage(totalPages);
            } else {
              const totalPages = pages;
              setTotalPage(totalPages);
            }
          }
        }
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });

    setModalRight(false);
  };
  const addJobBoards = (reqObj) => {
    JobBoardService.postjobboards(reqObj).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          toast.success("JobBoard added successfully");
          getjobBoard(sortOrder, sortBy, 1);
        }
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };
  const updateJobBoards = (updateJobBoard) => {
    JobBoardService.updateJobBoards(updateJobBoard, jobBoardId).then(
      (response) => {
        try {
          if (response.message != null) {
            if (response.data.error_message !== "") {
            }
          } else {
            toast.success("JobBoard updated successfully");
            getjobBoard(sortOrder, sortBy, 1);
          }
        } catch (err) {
          console.log("message" + JSON.stringify(err.message));
        }
      }
    );
  };

  const SubmitJobBoard = () => {
    if (jobBoardDetails.name === "") {
      toast.error("Please enter name");
      return;
    }
    const reqObj = {
      name: jobBoardDetails.name,
      description: jobBoardDetails.description,
      logo: uploadedImageUrl,
    };

    if (isNullOrEmpty(jobBoardId)) {
      addJobBoards(reqObj);
    } else {
      updateJobBoards(reqObj);
    }
    setModalRight(false);
  };

  const updateJobBoardDetail = (jobBoardDetails) => {
    setModalRight(true);
    let logo = jobBoardDetails.logo;
    if (!isNullOrEmpty(logo)) {
      setUploadedImageUrl(logo);
    } else {
      setUploadedImageUrl("");
    }

    setJobBoardId(jobBoardDetails.id);
    setSelectedImage("");
    if (document.getElementById("upload-jobBoard-image") !== null) {
      document.getElementById("upload-jobBoard-image").value = null;
    }

    setUpdateImageDisabled(false);

    if (jobBoardDetails.name !== null || jobBoardDetails.name !== "") {
      setJobBoardDetails((prevState) => ({
        ...prevState,
        name: jobBoardDetails.name,
      }));
    }
    if (jobBoardDetails.email !== null || jobBoardDetails.email !== "") {
      setJobBoardDetails((prevState) => ({
        ...prevState,
        description: jobBoardDetails.description,
      }));
    }
    setSelectedJobBoard(jobBoardDetails);
  };

  const displayTableHeaders = () => {
    return (
      <>
        <th className="w-5">S. No</th>
        <th className="w-10">Logo</th>

        <th onClick={() => sortByJobs("name")} className="w-10">
          <Row className="w-[100]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> Name </div>
            <div className="col">
              {sortBy == "name" ? (
                <>
                  {sortBy === "name" ? (
                    sortOrder === "desc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>
        <th className="w-10 ">Contact Name</th>
        <th className="w-10 ">Email</th>
        <th className="w-10 ">Mobile Number</th>
        <th onClick={() => sortByJobs("createdOn")} className="w-10">
          <Row className="w-[230]">
            <div className="col pr-1 t-cursor-pointer"> Creation Date </div>
            <div className="col">
              {sortBy === "createdOn" ? (
                <>
                  {sortBy === "createdOn" ? (
                    sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      // <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="0.8em" width="1em"><path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z" /></svg>
                      //  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="0.8em" width="1em"><path d="M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"/></svg>
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>
        <th className="w-10">
          <Row className="w-[200]">
            <div className="col pr-1"> Description </div>
          </Row>
        </th>

        <th className="w-10">Actions</th>
      </>
    );
  };

  const cancelButton = () => {
    setModalRight(false);
    // clearDetails();
  };

  const handledelete = (id, name) => {
    setDeleteBoard(id);
    setJobBoardName(name);
    setModalDelete(id);
  };

  const removejobBoard = () => {
    JobBoardService.deleteJobBoard(deleteBoard).then((response) => {
      try {
        toast.success("JobBoard deleted successfully");
        let jobBoardSize = boards.length;
        let currentPageSize = currentPage;
        if (jobBoardSize == 1) {
          if (currentPage !== 1) {
            currentPageSize = currentPage - 1;
          }
        }
        setCurrentPage(currentPageSize);
        getjobBoard(sortOrder, sortBy, 1);
      } catch (err) {
        console.log(err);
      }
      setModalDelete(false);
    });
  };

  const [selectedImage, setSelectedImage] = useState("");

  const onFileChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedImage(URL.createObjectURL(event.target.files[0]));
    }
    let file = document.getElementById("upload-jobBoard-image").files[0];
    let fd = new FormData();
    fd.append("file", file);
    setUpdateImageDisabled(true);
    JobBoardService.uploadJobBoardImage(fd).then((response) => {
      setUpdateImageDisabled(false);
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (response.data != null) {
            let uploadedImageResponse = response.data;
            if (!isNullOrEmpty(uploadedImageResponse.imageUrl)) {
              setUploadedImageUrl(uploadedImageResponse.imageUrl);
            } else {
              setUploadedImageUrl("");
            }
          }
        }
      } catch (err) {
        console.log("err " + JSON.stringify(err));
      }
    });
  };
  const getSerialNumber = (index) => {
    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }
    return (currentPage - 1) * itemsPerPage + index + 1;
  };
  return (
    <>
      <div>
        <div>
          <Card className="mt-2">
            <CardHeader>
              <div>
                <Row>
                  <Colxx xxs="12">
                    <div className="skill-header">
                      <strong>Job Boards</strong>
                      <Button
                        color="primary"
                        size="sm"
                        outline
                        onClick={openJobBoardModel}
                      >
                        Add
                      </Button>

                      <Modal
                        scrollable={true}
                        isOpen={modalRight}
                        toggle={() => setModalRight(!modalRight)}
                        wrapClassName="modal-right"
                      >
                        <ModalHeader className="Modal-header-account">
                          {jobBoardId === "" ? (
                            <strong>Create Job Board</strong>
                          ) : (
                            <strong>Update Job Board</strong>
                          )}
                        </ModalHeader>
                        <ModalBody>
                          <Form>
                            <FormGroup row>
                              <Colxx sm={12}>
                                <FormGroup>
                                  <Label>Name*</Label>
                                  <Input
                                    className="t-rounded-lg"
                                    type="name"
                                    name="name"
                                    data-testid="account-name"
                                    onChange={inputsHandler}
                                    value={jobBoardDetails.name}
                                  />
                                </FormGroup>
                              </Colxx>
                             
                              <Colxx sm={12}>
                                <FormGroup>
                                  <Label>Description</Label>
                                  <Input
                                    className="t-rounded-lg"
                                    type="textarea"
                                    name="description"
                                    data-testid="account-shortcode"
                                    onChange={inputsHandler}
                                    value={jobBoardDetails.description}
                                  />
                                </FormGroup>
                              </Colxx>

                              <>
                                <Colxx sm={12}>
                                  <div className="skill-header">
                                    <Label>
                                      <b>Job Board Logo</b>
                                    </Label>
                                    <>
                                      <label
                                        htmlFor="upload-jobBoard-image"
                                        className="btn btn-outline-primary fileinput-button btn-sm"
                                      >
                                        Upload
                                      </label>
                                      <input
                                        type="file"
                                        id="upload-jobBoard-image"
                                        accept="image/png,image/jpeg"
                                        style={{ display: "none" }}
                                        disabled={updateImageDisabled}
                                        onChange={(e) => {
                                          onFileChange(e, jobBoardDetails);
                                        }}
                                      />
                                    </>
                                  </div>
                                </Colxx>

                                <Colxx sm={12}>
                                  <FormGroup>
                                    <div className="skill-header">
                                      {uploadedImageUrl !== "" ? (
                                        <>
                                          <img
                                            src={uploadedImageUrl}
                                            alt="logo"
                                            className="account-logo"
                                          />
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </FormGroup>
                                </Colxx>
                              </>
                              {/* ) : (
                                <></>
                              )} */}
                            </FormGroup>
                          </Form>
                        </ModalBody>

                        <ModalFooter className="model-button modal-bottom-account">
                          <Button
                            color="primary"
                            size="sm"
                            outline
                            onClick={SubmitJobBoard}
                          >
                            Save
                          </Button>

                          <Button
                            color="primary"
                            size="sm"
                            outline
                            className=" ml-1"
                            onClick={cancelButton}
                          >
                            Cancel
                          </Button>
                        </ModalFooter>
                      </Modal>
                    </div>
                  </Colxx>
                </Row>
              </div>
            </CardHeader>
            <CardBody>
              <div className="mb-3">
                <Row>
                  <Colxx xs={12}>
                    <Row>
                      <Colxx md={4}>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control t-input-group-left-radius "
                            name=""
                            placeholder="Search"
                            onChange={handleSearch}
                            value={search}
                          />
                          <div className="input-group-append">
                            <button
                              className="btn btn-outline-primary btn-sm t-input-group-right-radius"
                              onClick={(e) => getjobBoard(sortOrder, sortBy, 1)}
                            >
                              Search
                            </button>
                          </div>
                        </div>
                      </Colxx>
                      <Colxx md={4}></Colxx>
                      <Colxx md={4}>
                        <Input
                          className="t-rounded-lg"
                          type="select"
                          value={itemsPerPage}
                          onChange={handleItemsPerChange}
                        >
                          <option value={""}>Items Per Page</option>
                          <option value={"10"}>10</option>
                          <option value={"25"}>25</option>
                          <option value={"50"}>50</option>
                          <option value={"100"}>100</option>
                        </Input>
                      </Colxx>
                    </Row>
                  </Colxx>
                </Row>
              </div>
              <Colxx sm={12} className="mt-2 location-table">
                <div>
                  <div className="tableContainer">
                    <div className="tablewrapper">
                      <Table className="hms_table  jobRequisition_table  table-responsive">
                        <thead>
                          <tr>{displayTableHeaders()}</tr>
                        </thead>
                        {boards.length > 0 ? (
                          boards.map((board, index) => {
                            const startDate = new Date(
                              board.createdOn
                            ).toDateString();
                            return (
                              <tbody key={board.id + index}>
                                <tr>
                                  <td className="w-[60]">
                                    {getSerialNumber(index)}
                                  </td>
                                  <td className="w-[120]">
                                    {!isNullOrEmpty(board.logo) ? (
                                      <>
                                        <img
                                          src={board.logo}
                                          className="account-logo"
                                        ></img>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </td>
                                  <td className="w-[120]">
                                    <u>
                                      <span
                                        className="text-dark t-cursor-pointer"
                                        title="Edit Job Board"
                                        onClick={() => {
                                          updateJobBoardDetail(board);
                                        }}
                                      >
                                        {board.name}
                                      </span>
                                    </u>
                                  </td>
                                  <td className="w-[120]">
                                    {!isNullOrEmpty(board.primaryContact) ? (
                                      <>
                                        {board.primaryContact.firstName}{" "}
                                        {board.primaryContact.lastName}
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </td>
                                  <td className="w-[120]">
                                    {!isNullOrEmpty(board.primaryContact) &&
                                      board.primaryContact.email}
                                  </td>
                                  <td className="w-[120]">
                                    {!isNullOrEmpty(board.primaryContact) &&
                                      formattedMobileNumber(
                                        board.primaryContact.mobileNumber
                                      )}
                                  </td>
                                  <td className="w-[120]">{startDate}</td>
                                  <td className="w-[60]">
                                    {board.description}
                                  </td>
                                  <td className="w-[60]">
                                    <div className="actionbutton">
                                      <Link
                                        className="benifit-symbol-color"
                                        to={`/jobboardcontacts`}
                                        title="Job Board Contacts"
                                        onClick={() => {
                                          window.localStorage.setItem(
                                            "jobboardId",
                                            board.id
                                          );
                                          window.localStorage.setItem(
                                            "jobboardName",
                                            board.name
                                          );
                                        }}
                                      >
                                        <i
                                          className=" w-5 simple-icon-user-follow mr-1 arrow-icon-color"
                                          color="red"
                                        />
                                      </Link>

                                      <i
                                        title="Delete Job Board"
                                        className="simple-icon-trash edit-copyiconsize arrow-icon-color mr-1 t-cursor-pointer"
                                        onClick={() =>
                                          handledelete(board.id, board.name)
                                        }
                                      />
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            );
                          })
                        ) : (
                          <tfoot></tfoot>
                        )}
                      </Table>
                    </div>
                  </div>

                  {boards == "" || boards == null ? (
                    <>
                      {" "}
                      <p className="nodata-text">No job boards are available</p>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </Colxx>
            </CardBody>
            <CardFooter>
              <Pagination
                currentPage={currentPage}
                totalPage={totalPage}
                numberLimit={itemsPerPage}
                firstIsActive={true}
                onChangePage={(e) => onChangePage(e)}
              />

              <h3> Total matching records : {size}</h3>
            </CardFooter>
          </Card>
        </div>
      </div>

      <Modal
        isOpen={Boolean(modalDelete)}
        toggle={() => setModalDelete(!modalDelete)}
      >
        <ModalBody>Do you want to delete {jobBoardName}?</ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModalDelete(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            size="sm"
            outline
            onClick={(e) => {
              removejobBoard();
            }}
          >
            Delete
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default JobBoard;
